import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "error-header error-header-404" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "error-header-title" }, "Ошибка 404", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "error-header-info" }, "Здравствуйте! К сожалению, запрашиваемая вами страница недоступна.", -1 /* HOISTED */)
const _hoisted_5 = { class: "error-header-back" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "error-content error-content-404" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "error-content-title" }, "Возможные причины, почему вы оказались на этой странице:"),
  /*#__PURE__*/_createElementVNode("ul", { class: "error-content-list" }, [
    /*#__PURE__*/_createElementVNode("li", null, "Страница была удалена."),
    /*#__PURE__*/_createElementVNode("li", null, "У страницы был изменён адрес."),
    /*#__PURE__*/_createElementVNode("li", null, "Возможно, при вводе адреса была допущена ошибка (проверьте правильность написания адреса страницы). ")
  ])
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          class: "btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.goBack && $options.goBack(...args)))
        }, "Вернуться назад")
      ])
    ]),
    _hoisted_6
  ]))
}